import { paginationResolver } from '@/core/resolvers/pagination.resolver'
import { IHttpClient } from '@/core/services/http'
import { PaginatedResponse } from '@/core/types/api/paginated-response'
import { countryResolver } from '../resolvers/country.resolver'
import { CountryResponse } from '../types/api-responses/country-response'

type Params = {
  search?: string
  page?: number
  limit?: number
  isActive?: boolean
}

export function createGetCountriesUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (
    { isActive = true, limit = 10, page = 1, search = '' }: Params = {},
    { controller }: { controller?: AbortController } = {},
  ) {
    const res = await httpClient
      .version('v1')
      .paginate(page, limit)
      .get<{ data: PaginatedResponse<CountryResponse[]> }>(
        '/website/customer/countries',
        {
          params: {
            is_active: isActive ? '1' : '',
            search,
          },
          signal: controller?.signal,
        },
      )

    return {
      countries: countryResolver(res.data.data.data),
      pagination: paginationResolver(res.data.data.meta),
    }
  }
}
